/**
 * Project Colors Utility
 *
 * Maps Todoist project color names to brand palette hex values.
 * Use getProjectColor() to get a hex string for inline styles.
 */

export const BRAND_PALETTE = {
  teal:    '#08FCDD', // brand-1
  orange:  '#ff8629', // brand-2
  magenta: '#e504b9', // brand-3
  blue:    '#1c70af', // brand-4
  red:     '#db1c42', // brand-5
  yellow:  '#fbce57', // brand-6
  green:   '#70af1c', // brand-7
  neutral: '#71717a', // zinc-500 fallback
} as const;

/**
 * Todoist color name → brand palette hex
 */
const TODOIST_COLOR_MAP: Record<string, string> = {
  berry_red:   BRAND_PALETTE.red,
  red:         BRAND_PALETTE.red,
  orange:      BRAND_PALETTE.orange,
  salmon:      BRAND_PALETTE.orange,
  yellow:      BRAND_PALETTE.yellow,
  olive_green: BRAND_PALETTE.green,
  lime_green:  BRAND_PALETTE.green,
  green:       BRAND_PALETTE.green,
  mint_green:  BRAND_PALETTE.teal,
  teal:        BRAND_PALETTE.teal,
  sky_blue:    BRAND_PALETTE.blue,
  light_blue:  BRAND_PALETTE.blue,
  blue:        BRAND_PALETTE.blue,
  grape:       BRAND_PALETTE.magenta,
  violet:      BRAND_PALETTE.magenta,
  lavender:    BRAND_PALETTE.magenta,
  magenta:     BRAND_PALETTE.magenta,
  charcoal:    BRAND_PALETTE.neutral,
  grey:        BRAND_PALETTE.neutral,
  gray:        BRAND_PALETTE.neutral,
  taupe:       BRAND_PALETTE.neutral,
};

/**
 * Get the hex color for a project color name.
 * Returns a brand palette hex string for use in inline styles.
 */
export function getProjectColor(color?: string): string {
  if (!color) return BRAND_PALETTE.neutral;
  return TODOIST_COLOR_MAP[color] ?? BRAND_PALETTE.neutral;
}
